import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";

const photos = [
  "./2023-24headshot.jpg.JPG",
  "./IMG_0067.JPG",
  "./IMG_0101.JPG",
  "./IMG_1111.JPG",
  "./IMG_2995.jpeg",
];


export default function About() {
    return (
      <section id="about">
        <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
              Hello I'm Nicholas
              <br></br>
              I'm 
              <Typewriter
                words={[ 
                " a CS student at the University of Michigan",
                " interested in AI products, scalable backend systems, and high-performance computing.",
                " a former Five Rings Dev Intern", 
                " a Michigan Wolverine; Go Blue!"]}
                loop={5}
                cursor
                cursorStyle='/'
                typeSpeed={60}
                deleteSpeed={50}
                delaySpeed={1500}
              />
            </h1>
            <p className="mb-8 leading-relaxed">
              I just finished a summer dev internship at <a className="text-blue-400" href="https://fiverings.com/">Five Rings</a>, where I learned a lot designing and building some cool stuff.
	      Last winter, I studied abroad in <a className="text-red-400" href="https://en.wikipedia.org/wiki/Prague">Prague</a> and
              built an <a className="text-white" href="./WhomLab-x-Edinburgh-Final-Presentation.pdf"> interpretable ML model </a> for <a className="text-purple-300" href="https://whomlab.com/ " >WhomLab</a>. 
              <br></br>
              <br></br>
              I've recently been interested interested in running/lifting, reading, Rust, and Chicago.
            </p>
            <div className="flex justify-center">
              <a
                href="./Nicholas_Walvoord_resume.pdf"
                className="inline-flex text-white bg-gray-500 border-0 py-2 px-6 focus:outline-none hover:bg-gray-300 rounded text-lg">
                Resume
              </a>
              <a
                href="#projects"
                className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-300 hover:text-white rounded text-lg">
                See My Past Work
              </a>
            </div>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <Swiper
              modules={[EffectCards, Autoplay]}
              effect="cards"
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop
              className="rounded h-96"
            >
              {photos.map((src) => (
                <SwiperSlide key={src} className="flex items-center justify-center">
                  <img
                    className="h-full w-auto max-w-full rounded border-2 border-gray-500"
                    alt="hero"
                    src={src}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    );
}
